import styled, { css } from 'styled-components'

import {
  _S_Medium,
  _S_Normal,
  _XS_Bold,
  _XS_Normal,
  mainColors,
  semanticColors,
} from '@avantstay/backoffice-core'

export const Root = styled.section<{ $isWarning: boolean }>`
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;

  ${({ $isWarning }) =>
    $isWarning
      ? css`
          background: ${semanticColors.warningExtraLight};
        `
      : css`
          background: ${semanticColors.successExtraLight};
        `};
`

export const Label = styled.h3<{ $isWarning: boolean }>`
  ${_XS_Bold};
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 4px;
  color: ${({ $isWarning }) =>
    $isWarning ? semanticColors.warningExtraDark : semanticColors.successDark};
`

export const Lead = styled.p`
  ${_S_Medium};
  color: ${mainColors.primaryMedium};
  margin: 0;
  overflow-wrap: anywhere;
`

export const Said = styled.p`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark2};
  font-style: italic;
  margin: 4px 0 0;
  overflow-wrap: anywhere;
`

export const Trail = styled.p`
  ${_XS_Normal};
  color: ${mainColors.neutralExtremelyDark};
  margin: 8px 0 0;
  overflow-wrap: anywhere;
`
